<template>
    <div class="container-fluid" v-if="products.length">
        <h3 class="section-title">Покупают вместе</h3>
        <product-carousel :classes="classes" v-if="products.length" :items="products"></product-carousel>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        props: {
            items: {
                type: Array
            },
            classes: {
                type: String,
                default: () => ''
            }
        },
        mounted() {
            if (this.items) {
                this.$store.commit('product/setAssociatedAccessoryProducts', this.items);
            }
        },
        computed: {
            ...mapState('product', {
                products: 'associatedAccessoryProducts',
            }),
        }
    }
</script>
